/* ==========================================================================
   PETSOFY UI
   Rebuild of the inline lightbox + mobile dock previously in theme.liquid.

   Fixes carried over from the old version:
   - Add to cart used form.submit() (full page reload, bypassed the cart
     drawer). Now posts to /cart/add.js and opens the drawer.
   - Errors used alert(). Now surfaced inline.
   - Bound to every image on the page. Now scoped to product media only.
   - Ran on all markets then removed itself with JS. Now gated in Liquid.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.PetsofyUI || {};
  var strings = cfg.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- utils */

  function svg(paths, extra) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"' + (extra || '') + '>' +
      paths + '</svg>';
  }

  var ICONS = {
    close: svg('<path d="M18 6 6 18M6 6l12 12"/>'),
    prev: svg('<path d="m15 18-6-6 6-6"/>'),
    next: svg('<path d="m9 18 6-6-6-6"/>'),
    share: svg('<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/>'),
    cart: svg('<circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="M2 3h2.2l2.4 12.1a2 2 0 0 0 2 1.6h8.7a2 2 0 0 0 2-1.6L21 7H5"/>')
  };

  /* ------------------------------------------------------------- lightbox */

  function Lightbox(images, startIndex) {
    this.images = images;
    this.index = startIndex || 0;
    this.zoomed = false;
    this.build();
  }

  Lightbox.prototype.build = function () {
    var el = document.createElement('div');
    el.className = 'pf-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', strings.gallery || 'Product images');

    var multiple = this.images.length > 1;

    el.innerHTML =
      '<div class="pf-lightbox__top">' +
        '<span class="pf-lightbox__count"></span>' +
        '<button type="button" class="pf-icon-btn" data-pf="share">' + ICONS.share +
          '<span class="pf-icon-btn__label">' + (strings.share || 'Share') + '</span></button>' +
        '<button type="button" class="pf-icon-btn" data-pf="close" aria-label="' +
          (strings.close || 'Close') + '">' + ICONS.close + '</button>' +
      '</div>' +
      '<div class="pf-lightbox__stage">' +
        (multiple ? '<button type="button" class="pf-icon-btn pf-lightbox__nav pf-lightbox__nav--prev" data-pf="prev" aria-label="' + (strings.previous || 'Previous') + '">' + ICONS.prev + '</button>' : '') +
        '<img class="pf-lightbox__img" alt="">' +
        (multiple ? '<button type="button" class="pf-icon-btn pf-lightbox__nav pf-lightbox__nav--next" data-pf="next" aria-label="' + (strings.next || 'Next') + '">' + ICONS.next + '</button>' : '') +
      '</div>' +
      '<div class="pf-lightbox__bottom">' +
        (cfg.variantId ? '<button type="button" class="pf-icon-btn pf-icon-btn--primary" data-pf="add">' + ICONS.cart +
          '<span class="pf-icon-btn__label">' + (strings.addToCart || 'Add to cart') + '</span></button>' : '') +
      '</div>' +
      '<p class="pf-lightbox__status" role="status" aria-live="polite"></p>';

    document.body.appendChild(el);
    this.el = el;
    this.img = el.querySelector('.pf-lightbox__img');
    this.count = el.querySelector('.pf-lightbox__count');
    this.status = el.querySelector('.pf-lightbox__status');

    this.lastFocus = document.activeElement;
    document.body.style.overflow = 'hidden';

    this.render();
    this.bind();

    requestAnimationFrame(function () { el.classList.add('is-open'); });
    el.querySelector('[data-pf="close"]').focus();
  };

  Lightbox.prototype.render = function () {
    var src = this.images[this.index];
    this.img.src = src.full;
    this.img.alt = src.alt || '';
    this.count.textContent = (this.index + 1) + ' / ' + this.images.length;
    this.resetZoom();
  };

  Lightbox.prototype.go = function (step) {
    var n = this.images.length;
    this.index = (this.index + step + n) % n;
    var self = this;
    if (reduceMotion) return this.render();
    this.img.classList.add('is-swapping');
    setTimeout(function () {
      self.render();
      self.img.classList.remove('is-swapping');
    }, 140);
  };

  Lightbox.prototype.resetZoom = function () {
    this.zoomed = false;
    this.img.classList.remove('is-zoomed');
    this.img.style.transform = '';
  };

  Lightbox.prototype.bind = function () {
    var self = this;

    this.el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pf]');
      if (!btn) {
        if (e.target === self.el || e.target.classList.contains('pf-lightbox__stage')) self.close();
        return;
      }
      var action = btn.getAttribute('data-pf');
      if (action === 'close') self.close();
      if (action === 'prev') self.go(-1);
      if (action === 'next') self.go(1);
      if (action === 'share') self.share();
      if (action === 'add') self.addToCart(btn);
    });

    // Click-to-zoom, pointer-tracked pan while zoomed
    this.img.addEventListener('click', function (e) {
      e.stopPropagation();
      self.zoomed = !self.zoomed;
      self.img.classList.toggle('is-zoomed', self.zoomed);
      if (!self.zoomed) self.img.style.transform = '';
    });

    this.img.addEventListener('mousemove', function (e) {
      if (!self.zoomed) return;
      var r = self.img.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - 0.5) * -40;
      var y = ((e.clientY - r.top) / r.height - 0.5) * -40;
      self.img.style.transform = 'scale(2) translate(' + x + '%, ' + y + '%)';
    });

    // Swipe
    var startX = 0;
    this.el.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    this.el.addEventListener('touchend', function (e) {
      if (self.zoomed || self.images.length < 2) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) self.go(dx < 0 ? 1 : -1);
    }, { passive: true });

    this.keyHandler = function (e) {
      if (e.key === 'Escape') self.close();
      if (e.key === 'ArrowRight') self.go(1);
      if (e.key === 'ArrowLeft') self.go(-1);
    };
    document.addEventListener('keydown', this.keyHandler);
  };

  Lightbox.prototype.share = function () {
    var url = window.location.href;
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      var self = this;
      navigator.clipboard.writeText(url).then(function () {
        self.say(strings.linkCopied || 'Link copied');
      });
    }
  };

  Lightbox.prototype.say = function (msg) {
    this.status.textContent = msg;
  };

  Lightbox.prototype.addToCart = function (btn) {
    var self = this;
    var id = cfg.variantId;
    if (!id) return;

    btn.disabled = true;

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        if (!res.ok) {
          self.say(res.data.description || strings.cartError || 'Could not add to cart');
          return;
        }
        self.say(strings.added || 'Added to cart');
        self.close();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          document.dispatchEvent(new CustomEvent('pf:cart-updated'));
          drawer.open();
        } else {
          window.location.href = window.routes.cart_url;
        }
      })
      .catch(function () {
        btn.disabled = false;
        self.say(strings.cartError || 'Could not add to cart');
      });
  };

  Lightbox.prototype.close = function () {
    var el = this.el;
    document.removeEventListener('keydown', this.keyHandler);
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    setTimeout(function () { el.remove(); }, reduceMotion ? 0 : 280);
  };

  /* ------------------------------------------------------- lightbox wiring */

  function initLightbox() {
    // Scoped to product media only — the old build hijacked every image
    var scope = document.querySelector('.product__media-wrapper, product-information, .product__media-list');
    if (!scope) return;

    var nodes = scope.querySelectorAll('.product__media img, .product-single__media img');
    if (!nodes.length) return;

    var images = Array.prototype.map.call(nodes, function (img) {
      var src = img.currentSrc || img.src;
      return { full: src.replace(/(\?|&)width=\d+/, '$1width=2048'), alt: img.alt };
    });

    Array.prototype.forEach.call(nodes, function (img, i) {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function (e) {
        e.preventDefault();
        new Lightbox(images, i);
      });
    });
  }

  /* ----------------------------------------------------------- mobile bar */

  function initBar() {
    var bar = document.querySelector('.pf-bar');
    var wa = document.querySelector('.pf-wa');
    if (!bar && !wa) return;

    if (bar) document.body.classList.add('pf-has-bar');

    var last = window.pageYOffset;
    var ticking = false;

    function update() {
      var y = window.pageYOffset;
      var drawerOpen = document.querySelector('cart-drawer.active, .drawer.active, header-drawer details[open]');
      var hide = !!drawerOpen || (y > last && y > 140);
      if (bar) bar.classList.toggle('is-hidden', hide);
      if (wa) wa.classList.toggle('is-hidden', hide);
      last = y <= 0 ? 0 : y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* -------------------------------------------------------------- startup */

  function init() { initLightbox(); initBar(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after Shopify section re-renders (variant change, quick add)
  document.addEventListener('shopify:section:load', initLightbox);
})();
